// FioNova mobile-first onboarding layout. The experience stays phone-width and
// centered even on desktop (per source-of-truth fidelity), on the ivory canvas.
import { ChevronLeft } from "lucide-react";

export const OnboardingLayout = ({
  children,
  onBack,
  footer,
  headerRight,
  testId,
  contentClassName = "",
  immersive = true,
}) => {
  return (
    <div className={`min-h-screen w-full ${immersive ? "fio-immersive" : "bg-background"}`} data-testid={testId}>
      {immersive && <div className="fio-ambient" aria-hidden><span /><i /></div>}
      <div className="mx-auto flex min-h-screen w-full max-w-[460px] flex-col px-6 sm:px-8">
        {(onBack || headerRight) && (
          <div className="flex h-14 shrink-0 items-center justify-between">
            {onBack ? (
              <button
                type="button"
                onClick={onBack}
                data-testid="onboarding-back"
                aria-label="Go back"
                className="-ml-2 flex h-10 w-10 items-center justify-center rounded-full text-foreground/70 transition-colors hover:bg-black/5"
              >
                <ChevronLeft className="h-6 w-6" />
              </button>
            ) : <span />}
            {headerRight}
          </div>
        )}
        <div className={`flex flex-1 flex-col ${contentClassName}`}>{children}</div>
        {footer && <div className="shrink-0 pb-8 pt-4">{footer}</div>}
      </div>
    </div>
  );
};
